import script from "./SubscriptionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionDetail.vue?vue&type=style&index=0&id=aed315da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aed315da"]])

export default __exports__